import axios from '@/axios.js'

export default ({
  isRegistered: false,
  namespaced: true,
  state: {
    operadores: [],
    tiposClientes: [],
    valProductos: [],
    sectores: [],
    estados: [],
    municipios: [],
    provincias: []
  },
  actions: {
    getOperadores ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/val_productos?propiedades[]=operador')
          .then((response) => {
            commit('setOperadoresMutation', response.data['hydra:member'])
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getTiposClientes ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/val_productos?propiedades[]=tipoCliente')
          .then((response) => {
            commit('setTiposClientesMutation', response.data['hydra:member'])
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getTiposProductos ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/val_productos?propiedades[]=tipoProducto')
          .then((response) => {
            commit('setTiposProductosMutation', response.data['hydra:member'])
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getValProductosByOperadorCliente ({ commit }, busqueda) {       
      return new Promise((resolve, reject) => {
        axios.get(`/api/val_productos?operador=${busqueda.operador}&tipoCliente=${busqueda.tipoCliente}`)
          .then((response) => {            
            commit('setValProductosMutation', response.data['hydra:member'])            
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getSectores ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/val_sectors')
          .then((response) => {
            commit('setSectoresMutation', response.data['hydra:member'])
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getEstados ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/val_estados')
          .then((response) => {
            commit('setEstadosMutation', response.data['hydra:member'])
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getMunicipios ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/val_municipios')
          .then((response) => {
            commit('setMunicipiosMutation', response.data['hydra:member'])
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getProvincias ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/val_provincias')
          .then((response) => {
            commit('setProvinciasMutation', response.data['hydra:member'])
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getPersona ({ commit }, dni) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/personas?dni=${dni}`)
          .then((response) => {
            // commit('setPersonaMutation', response.data['hydra:member'])
            resolve(response.data['hydra:member'])
          })
          .catch((error) => { reject(error) })
      })
    }
  },
  mutations: {
    setOperadoresMutation (state, valProductos) {
      const operadores = []
      let op = ''
      valProductos.forEach((producto) => {
        if (op !== producto.operador && producto.operador !== undefined) {
          operadores.push({ 'id': producto.operador, 'nombre': producto.operador })
          op = producto.operador
        }
      })
      state.operadores = operadores
    },
    setTiposClientesMutation (state, valProductos) {
      const tiposClientes = []
      let op = ''
      valProductos.forEach((producto) => {
        if (op !== producto.tipoCliente && producto.tipoCliente !== undefined) {
          tiposClientes.push({ 'id': producto.tipoCliente, 'nombre': producto.tipoCliente })
          op = producto.tipoCliente
        }
      })      
      state.tiposClientes = tiposClientes
    },
    setTiposProductosMutation (state, valProductos) {
      const tiposProductos = []
      let op = ''
      valProductos.forEach((producto) => {
        if (op !== producto.tipoProducto && producto.tipoProducto !== undefined) {
          tiposProductos.push({ 'id': producto.tipoProducto, 'nombre': producto.tipoProducto, 'seccion': producto.seccion })
          op = producto.tipoProducto
        }
      })      
      state.tiposProductos = tiposProductos
    },
    setValProductosMutation (state, productos) { 
      state.valProductos = []             
      state.valProductos = productos
    },
    setSectoresMutation (state, sectores) {
      state.sectores = sectores
    },
    setEstadosMutation (state, estados) {
      state.estados = estados
    },
    setMunicipiosMutation (state, municipios) {
      state.municipios = municipios
    },
    setProvinciasMutation (state, provincias) {
      state.provincias = provincias
    }
  },
  modules: {}
})